"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItem = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var CartItem = function (_a) {
    var file = _a.file, onRemoveItem = _a.onRemoveItem, showCartInfoText = _a.showCartInfoText, cartItemsCount = _a.cartItemsCount;
    var handleRemoveItem = function () {
        onRemoveItem(file.id);
        if (cartItemsCount <= 1)
            showCartInfoText(false);
    };
    return (React.createElement(sok_ui_1.Table.Row, { key: file.id, className: "cart-item" },
        React.createElement(sok_ui_1.Table.Column, { className: "narrow" },
            React.createElement("span", null, file.type === 'FOLDER' ? (React.createElement(Icon_1.Icon, { className: "fa-folder" })) : (React.createElement(Icon_1.Icon, { className: "fa-file" })))),
        React.createElement(sok_ui_1.Table.Column, { className: "title" },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, file.path) },
                React.createElement("div", { className: "filename" }, file.name))),
        React.createElement(sok_ui_1.Table.Column, { className: "narrow" },
            React.createElement("span", { className: "remove-item", onClick: handleRemoveItem },
                React.createElement(Icon_1.Icon, { className: "fa-times" })))));
};
exports.CartItem = CartItem;
